import { mapState, mapActions } from "vuex";
import DialogLoader from "@/components/dialog/DialogLoader.vue";
import { _message } from "@/helpers/_message";
import i18n from "@/helpers/i18n";
export default {
  components: {
    DialogLoader,
  },
  props: {
    screenAction: {
      type: String,
      default: "DangKy",
    },
    file: {
      name: "",
    },
    loaiDot: {
      type: String,
      default: "HOCBA",
    },
  },
  computed: {
    ...mapState({
      truonglop10: (state) => state.truong.truonglop10,
      truonglop11: (state) => state.truong.truonglop11,
      truonglop12: (state) => state.truong.truonglop12,
      thisinh: (state) => state.thisinh.thisinh,
      nguyenvongs: (state) => state.nguyenvong.nguyenvongs,
      diems: (state) => state.tohop.diems,
      nganhs: (state) => state.nganh.nganhs,
      dotdangky: (state) => state.dotdangky.dotdangky,
      dotdangkythisinh: (state) => state.dotdangkythisinh.dotdangkythisinh,
      truongdaihoc: (state) => state.khaosat.truongdaihoc,
      khaosats: (state) => state.khaosat.khaosats,
      cosoes: (state) => state.coso.cosoes,
      hedaotaos: (state) => state.hedaotao.hedaotaos,
      nguyenvong: (state) => state.nguyenvong.nguyenvong,
      tinhs: (state) => state.truong.tinhs,
    }),
  },
  created() {
    const pdf_js = document.createElement("script");
    pdf_js.setAttribute("src", "/html2pdf/html2pdf.bundle.min.js");
    document.head.appendChild(pdf_js);
    window.scrollTo(0, 0);
  },
  methods: {
    ...mapActions({
      getNganhs: "nganh/getNganhs",
      createNguyenVongs: "nguyenvong/createNguyenVongs",
      dangKyThiSinh: "thisinh/dangKyThiSinh",
      updateThiSinh: "thisinh/updateThiSinh",
      updateThiSinhCaoHoc: "thisinh/updateThiSinhCaoHoc",
      dangKyThiSinhCaoHoc: "thisinh/dangKyThiSinhCaoHoc",
      createDotDangKyThiSinh: "dotdangkythisinh/createDotDangKyThiSinh",
    }),
    comeBack(value) {
      this.$emit("comeBack", value);
    },
    thongTinKhaoSat(ksTruongId) {
      let data = this.truongdaihoc.find(
        (item) => item.ksTruongId == ksTruongId
      );
      return `${data.maTruong} : ${data.tenTruong}`;
    },
    save() {
      this.$root.$dialogLoader.show(this.$t("message.saveData.title"), {});
      this.nguyenvong.chungChiNgoaiNgu = [
        ...(this.nguyenvong?.fileDinhKemCcnn ?? []),
      ];
      var vm = this;
      if (vm.screenAction == "DangKy") {
        if (this.thisinh.thiSinhId > 0) {
          if (this.dotdangky.loaiDot != "CAOHOC") {
            this.updateThiSinh({
              thisinh: this.thisinh,
              file: this.file,
            })
              .then(async (response) => {
                vm.readResponse(response);
              })
              .catch((error) => {
                console.error(error);
              });
          } else {
            this.updateThiSinhCaoHoc({
              thisinh: this.thisinh,
              nguyenvong: this.nguyenvong,
            })
              .then(async (response) => {
                vm.readResponse(response);
              })
              .catch((error) => {
                console.error(error);
              });
          }
        } else {
          if (this.dotdangky.loaiDot != "CAOHOC") {
            this.dangKyThiSinh({ thisinh: this.thisinh, file: this.file })
              .then(async (response) => {
                vm.readResponse(response);
              })
              .catch((error) => {
                console.error(error);
              });
          } else {
            this.dangKyThiSinhCaoHoc({
              thisinh: this.thisinh,
              nguyenvong: this.nguyenvong,
            })
              .then(async (response) => {
                vm.readResponse(response);
              })
              .catch((error) => {
                console.error(error);
              });
          }
        }
      } else {
        if (this.dotdangky.loaiDot != "CAOHOC") {
          this.updateThiSinh({
            thisinh: this.thisinh,
            file: this.file,
          })
            .then(async (response) => {
              vm.readResponse(response);
            })
            .catch((error) => {
              console.error(error);
            });
        } else {
          this.updateThiSinhCaoHoc({
            thisinh: this.thisinh,
            nguyenvong: this.nguyenvong,
          })
            .then(async (response) => {
              vm.readResponse(response);
            })
            .catch((error) => {
              console.error(error);
            });
        }
      }
    },
    saveAs(uri, filename) {
      var link = document.createElement("a");
      if (typeof link.download === "string") {
        link.href = uri;
        link.download = filename;

        //Firefox requires the link to be in the body
        document.body.appendChild(link);

        //simulate click
        link.click();

        //remove the link when done
        document.body.removeChild(link);
      } else {
        window.open(uri);
      }
    },

    readResponse(response) {
      this.$root.$dialogLoader.hide();
      const vm = this;
      const pdf_js = document.createElement("script");
      pdf_js.setAttribute("src", "/html2pdf/html2pdf.bundle.min.js");
      document.head.appendChild(pdf_js);
      switch (response.status) {
        case 200:
        case 201:
        case 204:
          vm.comeBack("dang_ky_xong");
          break;
        case 403:
          _message.messageErrorServer(response.data);
          break;
        default:
          _message.messageLoiDangKy(response.data.message);
          break;
      }
    },
    showNameFile(files) {
      let html = "";
      if (files instanceof Array) {
        files.forEach((x) =>
          x
            ? (html += `<li><a href="${window.URL.createObjectURL(
                x
              )}" target="_blank">${x.name}</a></li>`)
            : null
        );
      } else if (files && files.split(" ").length > 0) {
        const names = files.split(" ");
        names.forEach((x) => (html += `<li>${x}</li>`));
      }
      return html;
    },
  },
  filters: {
    khuVuc: function(value) {
      return value == "00" ? i18n.t("models.thiSinh.notUuTien") : value;
    },
    tenTruong: function(value, arrayTruong) {
      let truong = arrayTruong.find((item) => item.truongId == value);
      return `${truong?.truongId} - ${truong?.tenTruong} - ${truong?.diaChiTruong}`;
    },
    maNganh: function(value, nganhs) {
      let nganh = nganhs.find((item) => item.nganhId == value);
      return `${nganh?.maNganh} - ${nganh?.tenNganh}`;
    },

    toHop(tohop) {
      return `${tohop.maToHop} (${tohop.tenToHop})`;
    },
    checkFileName(value) {
      if (value == null) return i18n.t("message.fileUpload");
      return value.name;
    },
    tenCoSo: function(value, nganhs, cosoes) {
      let nganh = nganhs.find((item) => item.nganhId == value);
      let coso = cosoes.find((item) => item.coSoId == nganh?.coSoId);
      return `${coso?.maCoSo} - ${coso?.tenCoSo}`;
    },
    tenHeDaoTao: function(value, hedaotaos) {
      let hedaotao = hedaotaos.find((item) => item.heDaoTaoId == value);
      return `${hedaotao?.tenHeDaoTao}`;
    },
    noiSinh(value, tinhs) {
      const tinh = tinhs.find((item) => item.maTinh == value);
      return tinh?.tenTinh;
    },
    chooseHocThiTiengAnh(value) {
      switch (value) {
        case "KHONG":
          return "Không đăng ký";
        case "THI":
          return "Thi Tiếng Anh";
        case "ONVATHI":
          return "Học ôn và Thi Tiếng Anh";
        default:
          return "";
      }
    },
  },
  watch: {
    file(value) {
      if (value == null) {
        return (this.file.name = "");
      }
    },
  },
  mounted() {
    this.$root.$dialogLoader = this.$refs.dialogLoader;
  },
};
